export const API_TIALAI =  "https://tialai.rotendaokab.go.id/api/";
export const TIALAI_UPLOADS = "https://tialai.rotendaokab.go.id";
export const API_TIMEOUT = 120000;

export const resolveUploadUrl = (fileUrl) => {
  if (!fileUrl) return "";
  if (fileUrl.startsWith("http://") || fileUrl.startsWith("https://")) return fileUrl;
  return `${TIALAI_UPLOADS}${fileUrl.startsWith("/") ? fileUrl : `/${fileUrl}`}`;
};

export const AUTH_LOGIN = `${API_TIALAI}auth/login`;
export const AUTH_REGISTER = `${API_TIALAI}auth/register`;
export const AUTH_ME = `${API_TIALAI}auth/me`;

export const JENIS_IZIN = `${API_TIALAI}jenis-izin`;
export const PENGAJUAN = `${API_TIALAI}pengajuan`;
export const VERIFIKASI = `${API_TIALAI}verifikasi`;

// Alias lama — hindari error import sementara
export const API_HOHOLOK = API_TIALAI;
export const HOHOLOK_UPLOADS = TIALAI_UPLOADS;
